import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Textarea } from '@/components/ui/textarea';
import { StickyNote } from 'lucide-react';
import type { Asset } from '@/types/asset';

interface AssetDetailNotesProps {
  readonly asset: Asset;
  readonly onAssetUpdate: (asset: Asset) => void;
  readonly isEditMode?: boolean;
}

export function AssetDetailNotes({ asset, onAssetUpdate, isEditMode = false }: Readonly<AssetDetailNotesProps>) {
  const handleNotesChange = (value: string) => {
    onAssetUpdate({ ...asset, notes: value });
  };

  return (
    <div className="space-y-6">
      <Card className="border border-border/40">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <StickyNote className="h-5 w-5" />
            Notes
          </CardTitle>
        </CardHeader>
        <CardContent>
          {isEditMode ? (
            <Textarea
              value={asset.notes ?? ''}
              onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => handleNotesChange(e.target.value)}
              placeholder="Add notes about this asset..."
              className="min-h-[300px] resize-none"
            />
          ) : (
            <Textarea
              value={asset.notes ?? ''}
              readOnly
              className="min-h-[300px] resize-none bg-muted"
            />
          )}
        </CardContent>
      </Card>
    </div>
  );
}
